module.exports = __webpack_public_path__ + "eap-icon-d4c77ca934de50790f18c8e8444464d9.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/img/eap-icon.png
// module id = 502
// module chunks = 0